import { isBrowser } from './isBrowser';
export function isExplorer(): boolean {
  if (!isBrowser()) {
    return false;
  }
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  return msie > 0 || Boolean(/Trident.*rv:11\./.exec(ua));
}
